import { GridPaginationModel } from '@mui/x-data-grid-pro';
import useGetUserOrganization from 'hooks/useGetUserOrganization';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'store';
import {
  getJamfAssets,
  setPaginationModel as setJamfAssetsPaginationModel
} from 'store/slices/integrations/jamf/assets';
import {
  selectJamfAssets,
  selectJamfAssetsCount,
  selectJamfAssetsLoading,
  selectJamfAssetsPaginationModel
} from 'store/slices/integrations/jamf/assets/selectors';
import { COLUMNS } from './constants';
import { useTransformToTableData } from './utils';

export const useGetJamfAssetsTableConfig = () => {
  const dispatch = useDispatch<AppDispatch>();
  const organization = useGetUserOrganization();
  
  const jamfAssets = useSelector(selectJamfAssets);
  const jamfAssetsCount = useSelector(selectJamfAssetsCount);
  const loading = useSelector(selectJamfAssetsLoading) === 'pending';
  const paginationModel = useSelector(selectJamfAssetsPaginationModel);
  
  useEffect(() => {
    if (organization?.id) {
      dispatch(getJamfAssets({
        organizationId: organization.id,
        paginationModel
      }));
    }
  }, [dispatch, organization?.id, paginationModel]);
  
  const rows = useTransformToTableData(jamfAssets);
  const columns = COLUMNS;
  
  const handlePaginationModelChange = useCallback((newModel: GridPaginationModel) => {
    dispatch(setJamfAssetsPaginationModel(newModel));
  }, [dispatch]);
  
  return {
    rows,
    columns,
    rowCount: jamfAssetsCount,
    pagination: true,
    paginationModel,
    loading,
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 25, 50],
  };
}; 
